
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as env8hCY6sSwkS5U9ySQOM6LWwZ17_RqqbBxm2lR8hIEZl0Meta } from "/root/injective/injective-helix/app/pages/env.vue?macro=true";
import { default as spotgYu0RabFTF0zvAMitOi6x0i5jgruVY15oWjZqACc1UkMeta } from "/root/injective/injective-helix/app/pages/spot.vue?macro=true";
import { default as swapmpmHALagGCccT_t_r_vQayds1UCJsRBjh9a0_2lH8hwMeta } from "/root/injective/injective-helix/app/pages/swap.vue?macro=true";
import { default as indexm5v_xamwhsWKuRQ8mwVLaDlvztCjJfb8eGYj1l8dhtAMeta } from "/root/injective/injective-helix/app/pages/index.vue?macro=true";
import { default as termsHvcD0uRCmPFoyAUyyuKnon2IeSigNw3Z2ELNXnBuaf0Meta } from "/root/injective/injective-helix/app/pages/terms.vue?macro=true";
import { default as guildsJl2gA6acpM7nPS1OGmmbeoLoC8KOoPS2cQny8UCryl8Meta } from "/root/injective/injective-helix/app/pages/guilds.vue?macro=true";
import { default as mobilevvUfTzDirtQkVDqdGnbXWaYCgn37OyblIsNcRZsBZrgMeta } from "/root/injective/injective-helix/app/pages/mobile.vue?macro=true";
import { default as pointsjIJRqPKhJl9pWAxJkhP7I6xkYwnrIoPWAJcWm_8hycwMeta } from "/root/injective/injective-helix/app/pages/points.vue?macro=true";
import { default as vaultsDuhAb7Upc75vPwZzKwjzME_34fpVNsDH8_VqAMXsJxoMeta } from "/root/injective/injective-helix/app/pages/vaults.vue?macro=true";
import { default as futuresjoW1edeJNLFgN7hYwat8BMzYDWKmH6XT7on63sC8I8YMeta } from "/root/injective/injective-helix/app/pages/futures.vue?macro=true";
import { default as localesp2pYLOg8G_Z0Hazc_TY9KPXlx1Nh7sIK7N8V3HZm7h8Meta } from "/root/injective/injective-helix/app/pages/locales.vue?macro=true";
import { default as marketsZTvwuq4BxlTG1svuqe4o0R4kTREDvdSJneZhADQNDngMeta } from "/root/injective/injective-helix/app/pages/markets.vue?macro=true";
import { default as sandboxhwHLQ182AIg1hkWjMHjhD_RFuj_JhIu35uRhgziHhi4Meta } from "/root/injective/injective-helix/node_modules/.c12/github_InjectiveLabs_injective_B5Ll5JMqHu/app/pages/sandbox.vue?macro=true";
import { default as indext9ouHOPjb1ItTEoWdTZ7a_l_1IZvwV8e9jXHGrYxKewMeta } from "/root/injective/injective-helix/app/pages/portfolio/index.vue?macro=true";
import { default as positionssg9ZqVf_R44cQN7LpHv3YmrG_g7_GMIXqXIc0_71NyAMeta } from "/root/injective/injective-helix/app/pages/portfolio/positions.vue?macro=true";
import { default as spotjhJOl8oI2KCsvQbGLapqRwSXJZ_1zjMWxcxOMcYdZMcMeta } from "/root/injective/injective-helix/app/pages/portfolio/orders/spot.vue?macro=true";
import { default as subaccounts0epWCa6SYZeKnF3aRHYIrYlwOwlFakXEl4d_XKFpu2QMeta } from "/root/injective/injective-helix/app/pages/portfolio/subaccounts.vue?macro=true";
import { default as futuresBsiQg8ZIkF7c4CMpOKpCnna3t6UXbhr_vHBsyzptDRAMeta } from "/root/injective/injective-helix/app/pages/portfolio/orders/futures.vue?macro=true";
import { default as index42X6p54g0ic6ObAp4hA4NGgyy_2n6hNXOPtBaIGKJWMMeta } from "/root/injective/injective-helix/app/pages/portfolio/settings/authz/index.vue?macro=true";
import { default as granteraRfQZNyNp95i_sY_SUpiWllvd4jKWcvsBbfnqN224MYMeta } from "/root/injective/injective-helix/app/pages/portfolio/settings/authz/granter.vue?macro=true";
import { default as authzAkr1umLQgVbVaMWuq6P1Ki3dlHQfMzHGDmpLLPWJPLoMeta } from "/root/injective/injective-helix/app/pages/portfolio/settings/authz.vue?macro=true";
import { default as indexgxdsoF3fk1q76acdrkmYQzQA9IHLaFOb7ojSW17M9pMMeta } from "/root/injective/injective-helix/app/pages/portfolio/settings/index.vue?macro=true";
import { default as funding_45historyTpWyzsZ4th6jc7EvzSo8fqyt9b3OoZh19NugGxC5UCUMeta } from "/root/injective/injective-helix/app/pages/portfolio/funding-history.vue?macro=true";
import { default as spotEPJ5Tq7qOlKpC_ylVD1X0yz_bicha73v4ZJVPFdeDHkMeta } from "/root/injective/injective-helix/app/pages/portfolio/order-history/spot.vue?macro=true";
import { default as swapi1MroNB36baE8dKmb_QxNPmW8_bnwGRuDBQXf1XHjQ4Meta } from "/root/injective/injective-helix/app/pages/portfolio/order-history/swap.vue?macro=true";
import { default as spottXBiM2d7M2wtIjyk5EfChbujGKKqUTDY548k6xqGCUgMeta } from "/root/injective/injective-helix/app/pages/portfolio/trade-history/spot.vue?macro=true";
import { default as subaccounts_45historyTVxBzbJfXSj_e5uLrhrF3bJ97SMt3dUJKEykJAL85PcMeta } from "/root/injective/injective-helix/app/pages/portfolio/subaccounts-history.vue?macro=true";
import { default as futureserZlQKgbXdcts7aiu64HZxPQVwyoR8WGcWCvNvL30PYMeta } from "/root/injective/injective-helix/app/pages/portfolio/order-history/futures.vue?macro=true";
import { default as futuresTN_lcfRlr3grngBL7Tzk6IHYyBO944mm71q8LguHcicMeta } from "/root/injective/injective-helix/app/pages/portfolio/trade-history/futures.vue?macro=true";
import { default as portfolio8vMgcW0N3J6fbBoEt4LQSpEwCcobhZzRzWpiLi2QX1kMeta } from "/root/injective/injective-helix/app/pages/portfolio.vue?macro=true";
import { default as _91ref_93sxiqMI6kDp8At3DYXuqCY2yXhYj0sAl4lwo_JSl7wkoMeta } from "/root/injective/injective-helix/app/pages/ref/[ref].vue?macro=true";
import { default as index70dsJkoujqumHn3iVcECSIZigSZsQyswlFWBpuBlJqUMeta } from "/root/injective/injective-helix/app/pages/ref/index.vue?macro=true";
import { default as indexvnY5366X8S_G69DV220LCZE_RXEPm4a4shKD6LYCskUMeta } from "/root/injective/injective-helix/app/pages/lp-rewards/index.vue?macro=true";
import { default as campaignvTfR_JJiFtquHv_pwMKTaF2lQMIL3qMkORMawFjMdWAMeta } from "/root/injective/injective-helix/app/pages/lp-rewards/campaign.vue?macro=true";
import { default as dashboardG1jf0lnfIYE1519gq6SKJe2YwdWzs5YyMBa5N99UKBwMeta } from "/root/injective/injective-helix/app/pages/lp-rewards/dashboard.vue?macro=true";
import { default as lp_45rewardsEtY3bMbZUO_Ux3iSXMqTKKRNVbuTONb_BKNxWZBwiWQMeta } from "/root/injective/injective-helix/app/pages/lp-rewards.vue?macro=true";
import { default as playgroundEUxREoj52F0_iqD9jFyFxTyTZOjjxl_y96bZ8vkscsgMeta } from "/root/injective/injective-helix/node_modules/.c12/github_InjectiveLabs_injective_B5Ll5JMqHu/app/pages/playground.vue?macro=true";
import { default as helix_45vaultTW6rTAsyngKWFYIa2h6ZacTtNhpuyoW1J3UnCI_pNdgMeta } from "/root/injective/injective-helix/app/pages/helix-vault.vue?macro=true";
import { default as indexaftJtA4T8UJYSruRJnJtAmV1MOq1tMqF7esTaw4ypmAMeta } from "/root/injective/injective-helix/app/pages/leaderboard/index.vue?macro=true";
import { default as competitionQkIa_6YWl7hZE1SO5pxav1n9jhLYUVd0zu4A_8aPIpYMeta } from "/root/injective/injective-helix/app/pages/leaderboard/competition.vue?macro=true";
import { default as past_45competitionsJanh1JvQebCJHaKGA2dwmhYNDy7EMR_cg_8C_wNSUYkMeta } from "/root/injective/injective-helix/app/pages/leaderboard/past-competitions.vue?macro=true";
import { default as leaderboardN6IsWlU_wF4mS8PLYW3_rR6WnpXxNJB0d3GTQQpEmHkMeta } from "/root/injective/injective-helix/app/pages/leaderboard.vue?macro=true";
import { default as maintenanceEARjL92Jmizz4JjuHHCW5VmJ2JH0q0B77Fr0EpFRsc8Meta } from "/root/injective/injective-helix/app/pages/maintenance.vue?macro=true";
import { default as fee_45discountsuA_ySTB_qEDWCLojbGw0F4vbyszWcNXdNtGEBbAnBSMMeta } from "/root/injective/injective-helix/app/pages/fee-discounts.vue?macro=true";
import { default as _91guild_93J7HsSdQL_lOTcKiu5vRa5vr8vHiHO_v1C_7k8kkFmNYMeta } from "/root/injective/injective-helix/app/pages/guild/[guild].vue?macro=true";
import { default as institutionalpMGXfFnS95T9SiUt2jG30DRYetgGCo8q0_S_32KwiIoMeta } from "/root/injective/injective-helix/app/pages/institutional.vue?macro=true";
import { default as privacy_45policyC60caC4ZlNrLtOiEvAX1qFq6UbYeHne_kEERHb7LaT4Meta } from "/root/injective/injective-helix/app/pages/privacy-policy.vue?macro=true";
import { default as trade_45and_45earnswuYldCvtugHbQ0ViAVze0mmTxisQjTq_IOXGuWnDzMMeta } from "/root/injective/injective-helix/app/pages/trade-and-earn.vue?macro=true";
import { default as indexWqCLlcHEp9TmRdLaUJ9xOjqoQzNANCHwmr28Zxn_okYMeta } from "/root/injective/injective-helix/app/pages/trading-bots/index.vue?macro=true";
import { default as tesla_45competition_45termsCNKQTVSGD5fstWe0Gg5yRyiC_m1FowxLrZjr_4dJPDgMeta } from "/root/injective/injective-helix/app/pages/tesla-competition-terms.vue?macro=true";
import { default as like_45a_45g_45competition_45termsOXHnylCSUUVXh1fhSVyM73QaxPkClp7pzZT_QQkw1X0Meta } from "/root/injective/injective-helix/app/pages/like-a-g-competition-terms.vue?macro=true";
import { default as competition_45privacy_45policy_45tesla8EGAkQzMnYf_DECFbVRCXms9sMNXuTv3hsVKJhDjS9gMeta } from "/root/injective/injective-helix/app/pages/competition-privacy-policy-tesla.vue?macro=true";
import { default as volume_45victory_45competition_45termsMpFnlHTM6k6Lv77bSqzPQ_fW_SvLwuNkaOemQ78QKHMMeta } from "/root/injective/injective-helix/app/pages/volume-victory-competition-terms.vue?macro=true";
import { default as competition_45privacy_45policy_45gwagonVlWUhmyh8JvrF_jsVkrOAUOBzRVt56ESkIiesGL4MCkMeta } from "/root/injective/injective-helix/app/pages/competition-privacy-policy-gwagon.vue?macro=true";
import { default as own_45your_45assets_45competition_45termsFTFFxddOZ6zqLxdnWI_E9J474BCGzphHIu4xtP54LdwMeta } from "/root/injective/injective-helix/app/pages/own-your-assets-competition-terms.vue?macro=true";
import { default as indexYGyo3VgWps32mgqB13b_mH3Kuc5x1LAqFfXUG3knJ38Meta } from "/root/injective/injective-helix/app/pages/trading-bots/liquidity-bots/spot/index.vue?macro=true";
import { default as competition_45privacy_45policy_45own_45your_45assets9L_yucXckqlcHz6rgZzaG84aLbBaVGhEHrKOLXGuYoYMeta } from "/root/injective/injective-helix/app/pages/competition-privacy-policy-own-your-assets.vue?macro=true";
export default [
  {
    name: "env",
    path: "/env",
    meta: env8hCY6sSwkS5U9ySQOM6LWwZ17_RqqbBxm2lR8hIEZl0Meta || {},
    component: () => import("/root/injective/injective-helix/app/pages/env.vue")
  },
  {
    name: "spot",
    path: "/spot",
    component: () => import("/root/injective/injective-helix/app/pages/spot.vue")
  },
  {
    name: "swap",
    path: "/swap",
    meta: {"middleware":["swap"]},
    component: () => import("/root/injective/injective-helix/app/pages/swap.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/root/injective/injective-helix/app/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/root/injective/injective-helix/app/pages/terms.vue")
  },
  {
    name: "guilds",
    path: "/guilds",
    component: () => import("/root/injective/injective-helix/app/pages/guilds.vue")
  },
  {
    name: "mobile",
    path: "/mobile",
    meta: mobilevvUfTzDirtQkVDqdGnbXWaYCgn37OyblIsNcRZsBZrgMeta || {},
    component: () => import("/root/injective/injective-helix/app/pages/mobile.vue")
  },
  {
    name: "points",
    path: "/points",
    component: () => import("/root/injective/injective-helix/app/pages/points.vue")
  },
  {
    name: "vaults",
    path: "/vaults",
    component: () => import("/root/injective/injective-helix/app/pages/vaults.vue")
  },
  {
    name: "futures",
    path: "/futures",
    component: () => import("/root/injective/injective-helix/app/pages/futures.vue")
  },
  {
    name: "locales",
    path: "/locales",
    meta: localesp2pYLOg8G_Z0Hazc_TY9KPXlx1Nh7sIK7N8V3HZm7h8Meta || {},
    component: () => import("/root/injective/injective-helix/app/pages/locales.vue")
  },
  {
    name: "markets",
    path: "/markets",
    component: () => import("/root/injective/injective-helix/app/pages/markets.vue")
  },
  {
    name: "sandbox",
    path: "/sandbox",
    component: () => import("/root/injective/injective-helix/node_modules/.c12/github_InjectiveLabs_injective_B5Ll5JMqHu/app/pages/sandbox.vue")
  },
  {
    name: portfolio8vMgcW0N3J6fbBoEt4LQSpEwCcobhZzRzWpiLi2QX1kMeta?.name,
    path: "/portfolio",
    meta: { ...(portfolio8vMgcW0N3J6fbBoEt4LQSpEwCcobhZzRzWpiLi2QX1kMeta || {}), ...{"middleware":["connected"]} },
    component: () => import("/root/injective/injective-helix/app/pages/portfolio.vue"),
    children: [
  {
    name: "portfolio",
    path: "",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/index.vue")
  },
  {
    name: "portfolio-positions",
    path: "positions",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/positions.vue")
  },
  {
    name: "portfolio-orders-spot",
    path: "orders/spot",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/orders/spot.vue")
  },
  {
    name: "portfolio-subaccounts",
    path: "subaccounts",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/subaccounts.vue")
  },
  {
    name: "portfolio-orders-futures",
    path: "orders/futures",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/orders/futures.vue")
  },
  {
    name: authzAkr1umLQgVbVaMWuq6P1Ki3dlHQfMzHGDmpLLPWJPLoMeta?.name,
    path: "settings/authz",
    meta: authzAkr1umLQgVbVaMWuq6P1Ki3dlHQfMzHGDmpLLPWJPLoMeta || {},
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/settings/authz.vue"),
    children: [
  {
    name: "portfolio-settings-authz",
    path: "",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/settings/authz/index.vue")
  },
  {
    name: "portfolio-settings-authz-granter",
    path: "granter",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/settings/authz/granter.vue")
  }
]
  },
  {
    name: "portfolio-settings",
    path: "settings",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/settings/index.vue")
  },
  {
    name: "portfolio-funding-history",
    path: "funding-history",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/funding-history.vue")
  },
  {
    name: "portfolio-order-history-spot",
    path: "order-history/spot",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/order-history/spot.vue")
  },
  {
    name: "portfolio-order-history-swap",
    path: "order-history/swap",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/order-history/swap.vue")
  },
  {
    name: "portfolio-trade-history-spot",
    path: "trade-history/spot",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/trade-history/spot.vue")
  },
  {
    name: "portfolio-subaccounts-history",
    path: "subaccounts-history",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/subaccounts-history.vue")
  },
  {
    name: "portfolio-order-history-futures",
    path: "order-history/futures",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/order-history/futures.vue")
  },
  {
    name: "portfolio-trade-history-futures",
    path: "trade-history/futures",
    component: () => import("/root/injective/injective-helix/app/pages/portfolio/trade-history/futures.vue")
  }
]
  },
  {
    name: "ref-ref",
    path: "/ref/:ref()",
    component: () => import("/root/injective/injective-helix/app/pages/ref/[ref].vue")
  },
  {
    name: "ref",
    path: "/ref",
    component: () => import("/root/injective/injective-helix/app/pages/ref/index.vue")
  },
  {
    name: lp_45rewardsEtY3bMbZUO_Ux3iSXMqTKKRNVbuTONb_BKNxWZBwiWQMeta?.name,
    path: "/lp-rewards",
    component: () => import("/root/injective/injective-helix/app/pages/lp-rewards.vue"),
    children: [
  {
    name: "lp-rewards",
    path: "",
    component: () => import("/root/injective/injective-helix/app/pages/lp-rewards/index.vue")
  },
  {
    name: "lp-rewards-campaign",
    path: "campaign",
    component: () => import("/root/injective/injective-helix/app/pages/lp-rewards/campaign.vue")
  },
  {
    name: "lp-rewards-dashboard",
    path: "dashboard",
    component: () => import("/root/injective/injective-helix/app/pages/lp-rewards/dashboard.vue")
  }
]
  },
  {
    name: "playground",
    path: "/playground",
    meta: playgroundEUxREoj52F0_iqD9jFyFxTyTZOjjxl_y96bZ8vkscsgMeta || {},
    component: () => import("/root/injective/injective-helix/node_modules/.c12/github_InjectiveLabs_injective_B5Ll5JMqHu/app/pages/playground.vue")
  },
  {
    name: "helix-vault",
    path: "/helix-vault",
    meta: {"middleware":["mega-vault-whitelisted"]},
    component: () => import("/root/injective/injective-helix/app/pages/helix-vault.vue")
  },
  {
    name: leaderboardN6IsWlU_wF4mS8PLYW3_rR6WnpXxNJB0d3GTQQpEmHkMeta?.name,
    path: "/leaderboard",
    component: () => import("/root/injective/injective-helix/app/pages/leaderboard.vue"),
    children: [
  {
    name: "leaderboard",
    path: "",
    component: () => import("/root/injective/injective-helix/app/pages/leaderboard/index.vue")
  },
  {
    name: "leaderboard-competition",
    path: "competition",
    component: () => import("/root/injective/injective-helix/app/pages/leaderboard/competition.vue")
  },
  {
    name: "leaderboard-past-competitions",
    path: "past-competitions",
    component: () => import("/root/injective/injective-helix/app/pages/leaderboard/past-competitions.vue")
  }
]
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceEARjL92Jmizz4JjuHHCW5VmJ2JH0q0B77Fr0EpFRsc8Meta || {},
    component: () => import("/root/injective/injective-helix/app/pages/maintenance.vue")
  },
  {
    name: "fee-discounts",
    path: "/fee-discounts",
    component: () => import("/root/injective/injective-helix/app/pages/fee-discounts.vue")
  },
  {
    name: "guild-guild",
    path: "/guild/:guild()",
    component: () => import("/root/injective/injective-helix/app/pages/guild/[guild].vue")
  },
  {
    name: "institutional",
    path: "/institutional",
    meta: institutionalpMGXfFnS95T9SiUt2jG30DRYetgGCo8q0_S_32KwiIoMeta || {},
    component: () => import("/root/injective/injective-helix/app/pages/institutional.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/root/injective/injective-helix/app/pages/privacy-policy.vue")
  },
  {
    name: "trade-and-earn",
    path: "/trade-and-earn",
    component: () => import("/root/injective/injective-helix/app/pages/trade-and-earn.vue")
  },
  {
    name: "trading-bots",
    path: "/trading-bots",
    component: () => import("/root/injective/injective-helix/app/pages/trading-bots/index.vue")
  },
  {
    name: "tesla-competition-terms",
    path: "/tesla-competition-terms",
    component: () => import("/root/injective/injective-helix/app/pages/tesla-competition-terms.vue")
  },
  {
    name: "like-a-g-competition-terms",
    path: "/like-a-g-competition-terms",
    component: () => import("/root/injective/injective-helix/app/pages/like-a-g-competition-terms.vue")
  },
  {
    name: "competition-privacy-policy-tesla",
    path: "/competition-privacy-policy-tesla",
    component: () => import("/root/injective/injective-helix/app/pages/competition-privacy-policy-tesla.vue")
  },
  {
    name: "volume-victory-competition-terms",
    path: "/volume-victory-competition-terms",
    component: () => import("/root/injective/injective-helix/app/pages/volume-victory-competition-terms.vue")
  },
  {
    name: "competition-privacy-policy-gwagon",
    path: "/competition-privacy-policy-gwagon",
    component: () => import("/root/injective/injective-helix/app/pages/competition-privacy-policy-gwagon.vue")
  },
  {
    name: "own-your-assets-competition-terms",
    path: "/own-your-assets-competition-terms",
    component: () => import("/root/injective/injective-helix/app/pages/own-your-assets-competition-terms.vue")
  },
  {
    name: "trading-bots-liquidity-bots-spot",
    path: "/trading-bots/liquidity-bots/spot",
    component: () => import("/root/injective/injective-helix/app/pages/trading-bots/liquidity-bots/spot/index.vue")
  },
  {
    name: "competition-privacy-policy-own-your-assets",
    path: "/competition-privacy-policy-own-your-assets",
    component: () => import("/root/injective/injective-helix/app/pages/competition-privacy-policy-own-your-assets.vue")
  },
  {
    name: "stocks",
    path: "/futures/stocks",
    component: () => import("/root/injective/injective-helix/app/pages/futures.vue")
  },
  {
    name: "futures-slug",
    path: "/futures/:slug()",
    component: () => import("/root/injective/injective-helix/app/pages/futures.vue")
  },
  {
    name: "spot-slug",
    path: "/spot/:slug()",
    component: () => import("/root/injective/injective-helix/app/pages/spot.vue")
  }
]